import './breadcrumbs.less'

import React from 'react'
import {style} from 'util/style'

const styles = style('breadcrumbs', ['item'])

export const BreadCrumbs: React.FC = ({children, ...attrs}) => {
	return (
		<div className={styles} {...attrs}>
			{children}
		</div>
	)
}

export const BreadCrumbsItem: React.FC<{active?: boolean; to?: string}> = ({
	children,
	to,
	active,
	...attrs
}) => {
	const Tag = to ? 'a' : 'div'
	return (
		<Tag
			href={to ? `#${to}` : null}
			className={styles.item.is({active})}
			{...attrs}
		>
			<div className={styles.item('content')}>{children}</div>
		</Tag>
	)
}
